import { LogoutButton } from "../../common/button/LogoutButton";
import styled from "styled-components";
import { List, Typography } from "antd";
import { Link } from "react-router-dom";
import { useAuthContext } from "../context/useAuthContext";

export function AccountDropdown(args: { onLogout: () => void }) {
  const { onLogout } = args;

  const { auth } = useAuthContext();

  const mfaEnabled = auth?.mfaEligible ?? false;

  return (
    <Container>
      <List size={"small"}>
        <List.Item>
          <Typography.Text>{auth?.email}</Typography.Text>
        </List.Item>
        {mfaEnabled && (
          <List.Item>
            <Link to={"/app/otp/register"} target={"_blank"}>
              MFA 설정
            </Link>
          </List.Item>
        )}
        <List.Item>
          <LogoutButton onClick={onLogout} />
        </List.Item>
      </List>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  background-color: white;
  align-items: flex-end;
  //width: 320px;
  padding: 8px 16px;
  border: 1px solid #aaaaaa;
  margin-top: 16px;
  border-radius: 4px;
  flex-direction: column;
`;
